import { render, staticRenderFns } from "./EditTax.vue?vue&type=template&id=f6b9608a"
import script from "./EditTax.vue?vue&type=script&lang=js"
export * from "./EditTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports